The details of the position profile to be created.
